import { BrowserRouter, Routes, Route, Link } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { Header } from "./components/Header";
import { HomePage } from "./components/HomePage";
import { AboutPage } from "./components/AboutPage";
import { ServicesPage } from "./components/ServicesPage";
import { ContactPage } from "./components/ContactPage";
import { Facebook, Instagram } from "lucide-react"; // added icons

export default function App() {
  return (
      <HelmetProvider>
        <BrowserRouter>
          <div className="min-h-screen bg-white">
            <Header />
            <main>
              <Routes>
                <Route path="/" element={<HomePage />} />
                <Route path="/about" element={<AboutPage />} />
                <Route path="/services" element={<ServicesPage />} />
                <Route path="/contact" element={<ContactPage />} />
              </Routes>
            </main>

            {/* Footer */}
            <footer className="bg-gray-900 text-white py-12">
              <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
                  <div className="col-span-1 md:col-span-2">
                    <div className="flex items-center space-x-2 mb-4">
                      <div className="w-8 h-8 bg-[#075123] rounded-full flex items-center justify-center">
                        <span className="text-white text-sm font-bold">B</span>
                      </div>
                      <span className="text-xl font-bold">
                      BugBuddies Pest Solutions
                    </span>
                    </div>
                    <p className="text-gray-400 mb-2 italic">
                      "They can run... But they can't hide!"
                    </p>
                    <p className="text-gray-400 mb-4 max-w-md">
                      Professional pest control services you can trust.
                      We eliminate pests and keep them away for good,
                      using safe and effective methods.
                    </p>
                    <p className="text-gray-400">
                      Licensed & Insured • Eco-Friendly Solutions •
                      Satisfaction Guaranteed
                    </p>
                  </div>

                  <div>
                    <h3 className="font-semibold mb-4">Quick Links</h3>
                    <ul className="space-y-2">
                      <li>
                        <Link
                            to="/"
                            className="text-gray-400 hover:text-white transition-colors"
                        >
                          Home
                        </Link>
                      </li>
                      <li>
                        <Link
                            to="/about"
                            className="text-gray-400 hover:text-white transition-colors"
                        >
                          About Us
                        </Link>
                      </li>
                      <li>
                        <Link
                            to="/services"
                            className="text-gray-400 hover:text-white transition-colors"
                        >
                          Services
                        </Link>
                      </li>
                      <li>
                        <Link
                            to="/contact"
                            className="text-gray-400 hover:text-white transition-colors"
                        >
                          Contact Us
                        </Link>
                      </li>
                    </ul>
                  </div>

                  <div>
                    <h3 className="font-semibold mb-4">Contact Info</h3>
                    <ul className="space-y-2 text-gray-400 mb-6">
                      <li>(306) 201-7883</li>
                      <li>(306) 537-1423</li>
                      <li>info@bugbuddies.ca</li>
                      <li>Mon-Fri: 8AM - 6PM</li>
                      <li>Sat-Sun: By Appointment</li>
                    </ul>

                    {/* Social Media */}
                    <div className="flex space-x-4">
                      <a
                          href="https://www.facebook.com/share/1BECnGfp35/?mibextid=wwXIfr"
                          target="_blank"
                          rel="noopener noreferrer"
                          className="text-gray-400 hover:text-white transition-colors"
                      >
                        <Facebook className="h-5 w-5" />
                      </a>
                      <a
                          href="https://www.instagram.com/bugbuddies.ca?igsh=a2d3NmVsdWR4OWdm"
                          target="_blank"
                          rel="noopener noreferrer"
                          className="text-gray-400 hover:text-white transition-colors"
                      >
                        <Instagram className="h-5 w-5" />
                      </a>
                    </div>
                  </div>
                </div>

                <div className="border-t border-gray-800 mt-8 pt-8 text-center text-gray-400">
                  <p>
                    &copy; {new Date().getFullYear()} BugBuddies Pest Control. All rights reserved.
                  </p>
                </div>
              </div>
            </footer>
          </div>
        </BrowserRouter>
      </HelmetProvider>
  );
}
